export const exportKey = async (key: CryptoKey) => crypto.subtle.exportKey('jwk', key);
